import { ReactComponent as Empty } from '../../assets/empty.svg';

type NoResultsProps = {
    search: string;
};

function NoResults({ search }: NoResultsProps): JSX.Element {
    return (
        <div className="flex flex-col items-center gap-2">
            <Empty className=" scale-75" />
            <p className="text-sm text-gray-600">No results found for &quot;{search}&quot; </p>
        </div>
    );
}

export default NoResults;
